import styled from 'styled-components'
import { anatomyCompact } from '~/pages/anatomy/libs/responsive'
import { Styles as BaseStyles } from '~/pages/onboarding/quizBinaryChoice/libs/styles'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  ...BaseStyles,

  Root: styled(BaseStyles.Root)`
    ${anatomyCompact} {
      overflow-y: auto;
    }
  `,

  ImageContainer: styled(BaseStyles.ImageContainer)`
    box-shadow: none;
    min-height: 200px;
    max-width: 375px;

    picture {
      display: block;
      margin: 16px auto 0;
      max-width: 375px;
    }

    img {
      display: block;
      width: 100%;
    }
  `,

  TextWrapper: styled(BaseStyles.TextWrapper)`
    bottom: 26px;
  `,

  Subtitle: styled(BaseStyles.Subtitle)`
    letter-spacing: -0.154px;
    color: ${COLORS.BLACK};
  `,
}
